import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  setLoadingCheckout,
  setCheckoutData,
  setErrorCheckout,
  setLoadingPublicStkPush,
  setPublicStkPushSuccess,
  setErrorPublicStkPush,
} from "../slices/checkout";

// 1. Fetch Checkout Details
export const fetchCheckoutDetails =
  (token, isSilent = false) =>
  async (dispatch) => {
    if (!isSilent) {
      dispatch(setLoadingCheckout());
    }
    try {
      const { data } = await axiosInstance.get(
        `/auth/checkout?token=${token}`,
        {
          headers: { requiresAuth: false },
        },
      );

      if (data.status === "SUCCESS") {
        dispatch(setCheckoutData(data.data));
      }
    } catch (error) {
      const message = getErrorMessage(error);
      dispatch(setErrorCheckout(message));
    }
  };

// 2. Process Public STK Push
export const sendPublicStkPush = (payload, onSuccess) => async (dispatch) => {
  dispatch(setLoadingPublicStkPush());
  try {
    const { data } = await axiosInstance.post(`/auth/stk-push`, payload, {
      headers: { requiresAuth: false },
    });

    if (data.status === "SUCCESS") {
      toast.success("M-Pesa Prompt sent! Please check your phone.");
      dispatch(setPublicStkPushSuccess());
      if (onSuccess) onSuccess();
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorPublicStkPush(message));
  }
};
